import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const paymentsApi = createApi({
  reducerPath: 'payments',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['Payments'],

  endpoints: (builder) => ({

    // ---------------------- GET ALL PAYMENTS ----------------------
    getAllPayments: builder.query({
      query: ({ page = 1, keyword = '' }) => {
        let url = `admin/payment?pageno=${page}`;
        if (keyword) url += `&search=${keyword}`;
        return { url, method: 'GET' };
      },
      transformResponse: (res) => res, // handle pagination info here if backend returns it
      providesTags: ['Payments'],
    }),

    // ---------------------- GET SINGLE PAYMENT ----------------------
    getSinglePayment: builder.query({
      query: (id) => ({
        url: `admin/payment/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.body,
      providesTags: ['Payments'],
    }),

    // ---------------------- ADD NEW PAYMENT ----------------------
    addPayment: builder.mutation({
      query: (newPaymentData) => ({
        url: 'admin/payments',
        method: 'POST',
        body: newPaymentData,
      }),
      invalidatesTags: ['Payments'],
    }),

    // ---------------------- UPDATE PAYMENT ----------------------
    updatePayment: builder.mutation({
      query: (data) => ({
        url: `admin/payments/${data?.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Payments'],
    }),

    // ---------------------- DELETE PAYMENT ----------------------
    deletePayment: builder.mutation({
      query: (id) => ({
        url: `admin/payments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Payments'],
    }),
  }),
});

export const {
  useGetAllPaymentsQuery,
  useGetSinglePaymentQuery,
  useAddPaymentMutation,
  useUpdatePaymentMutation,
  useDeletePaymentMutation,
} = paymentsApi;
